var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"60vh"}},[[_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"h3"},[_vm._v("暂未开放敬请期待")]),_c('div',[_c('b-button',{attrs:{"size":"sm","pill":"","variant":"outline-primary","to":"/"}},[_vm._v("回到首页")])],1)])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }